<template>
  <v-container fluid class="pa-4 pa-md-6">
    <v-card elevation="5" class="rounded-lg">
      <v-card-title class="text-h5 primary white--text py-4">
        <v-icon left color="white">mdi-cash-register</v-icon>
        Calculadora de caixa
      </v-card-title>
      <v-divider></v-divider>

      <v-card-text class="pa-6">
        <v-row class="mb-6">
          <v-col cols="12">
            <div class="text-subtitle-1">
              <strong>Total Contado:</strong> {{ total | currency }}
            </div>
          </v-col>
        </v-row>

        <v-card outlined class="mb-6 rounded-lg">
          <v-card-text class="pa-4">
            <MoneyInput v-model="amount" @keydown.enter="add" @keydown.backspace="removeLastCash" label="Digite o valor"
              placeholder="0.00" prepend-inner-icon="mdi-currency-brl" outlined dense />
          </v-card-text>
        </v-card>

        <v-card outlined class="rounded-lg">
          <v-card-title class="subtitle-1 py-3">Calculadora de Notas</v-card-title>
          <v-card-text class="pa-4">
            <v-chip-group column>
              <v-chip v-for="(value, index) in cash" :key="index" color="primary" text-color="white" large class="ma-2">
                {{ value | currency }}
              </v-chip>
            </v-chip-group>
            <v-alert v-if="!cash.length" type="info" text dense class="mt-4">
              Nenhum valor adicionado ainda.
            </v-alert>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import { mapActions, mapState } from "vuex";

  export default {
    data() {
      return {

        amount: Number(localStorage.getItem("dialogCloseAmount")) || 0,
        cash: JSON.parse(localStorage.getItem("dialogCloseCash") || "[]"),
      };
    },
    watch: {
      cash: {
        handler(newVal) {
          localStorage.setItem("dialogCloseCash", JSON.stringify(newVal));
        },
        deep: true,
      },
      amount(newVal) {
        localStorage.setItem("dialogCloseAmount", newVal);
      },
    },
    methods: {
      ...mapActions("cashier", ["activeCashier", "closeCashier"]),
      ...mapActions("auth", ["logout", "getUser"]),
      add() {
        if (this.amount > 0) {
          this.cash.push(this.amount);
          this.amount = 0;
        }
      },
      removeLastCash() {
        this.cash.pop();
      },

    },
    computed: {
      ...mapState("auth", ["user"]),
      ...mapState("cashier", ["cashier"]),
      total() {
        return this.cash
          .reduce((prev, curr) => Number(prev) + Number(curr), 0)
          .toFixed(2);
      },
    },
    created() {
      this.activeCashier();
    },
  };
</script>

<style scoped>
  .v-card {
    border-radius: 8px;
  }
</style>
